"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _jquery = _interopRequireDefault(require("jquery"));

var _backbone = _interopRequireDefault(require("backbone"));

var _underscore = _interopRequireDefault(require("underscore"));

var _scriptjs = _interopRequireDefault(require("scriptjs"));

var _Global = _interopRequireDefault(require("models/Global"));

var _config = _interopRequireDefault(require("config"));

var _injectedUploader = require("../injectedUploader");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AccountImageView = _backbone.default.View.extend({
  events: {
    'click .account-img-edit-button': 'uploadImage',
    'click .account-img-edit-button-mobile': 'uploadImage',
    'click .icon-trash': 'removeAccountImage'
  },
  initialize: function initialize(options) {
    options = options || {};

    _underscore.default.bindAll(this, 'uploadImage', 'defaultSuccess', 'defaultError');

    this.uploaderPlugin = options.uploaderPlugin;

    if (!this.uploaderPlugin) {
      this.loadCloudinary(options.cloudinaryOptions);
    }

    this.uploadWidget = undefined;
    this.setOptions(options);
  },
  loadCloudinary: function loadCloudinary(cloudinaryOptions) {
    var thisView = this;
    (0, _scriptjs.default)(['https://cloudinary-upload-widget-ext.bizzabo.com/global/all.js'], function () {
      thisView.cloudinary = window.cloudinary;
      thisView.cloudinaryOptions = _underscore.default.defaults(cloudinaryOptions || {}, {
        cloud_name: _config.default.cloudinaryCloudName,
        upload_preset: _config.default.cloudinaryUploadPreset,
        cropping: 'server',
        multiple: false,
        max_image_width: 3000,
        max_image_height: 1024,
        show_powered_by: false,
        theme: 'minimal',
        resource_type: 'image',
        transformation: 'q_auto',
        client_allowed_formats: ['jpeg', 'jpg', 'gif', 'png', 'bmp', 'ico'],
        sources: ['local', 'url', 'camera']
      });
    });
  },
  setOptions: function setOptions(options) {
    if (this.options && this.options.attr && this.options.model) {
      this.stopListening(this.options.model);
    }

    this.options = _underscore.default.extend({
      imageSelector: null,
      // jQuery selector of image
      textSelector: null,
      // jQuery selector for text,
      text: '',
      // Text to show
      placeholderImage: null,
      // Defult image to show when there is no src
      attr: null,
      // Model Attribute for binding to image element
      model: null,
      // Model for binding,
      disableAviary: false,
      // Pass true to disable Aviary
      disableBinding: false // Pass true to disable binding

    }, options);

    if (this.options.attr && this.options.model && !this.options.disableBinding) {
      this.listenTo(this.options.model, 'change:' + this.options.attr, this.imageChanged);
      this.imageChanged();
    }
  },
  imageChanged: function imageChanged() {
    var imageURL = this.options.model.get(this.options.attr);
    this.$el.toggleClass('has-image', !!imageURL);
    this.$el.toggleClass('placeholder-image', !imageURL);

    if (this.options.imageSelector) {
      this.$(this.options.imageSelector).attr('src', imageURL || this.options.placeholderImage);
    }

    if (this.options.text && this.options.textSelector) {
      if (this.$el.hasClass('has-image')) {
        this.$(this.options.textSelector).text(this.options.text.replace('Upload', 'Change'));
      } else {
        this.$(this.options.textSelector).text(this.options.text);
      }
    }
  },
  removeAccountImage: function removeAccountImage(e) {
    this.options.attr && this.options.model.unset(this.options.attr);
    var imageRemoved = true;
    this.$('.center-image').addClass('hide');
    this.trigger('upload:success', imageRemoved);
    e.stopPropagation();
  },
  defaultSuccess: function defaultSuccess() {
    this.$('.center-image').removeClass('hide');
    this.options.attr && this.options.model.set(this.options.attr, this.image);
    this.trigger('upload:success');
    this.$('upload-file-action').html('Change image');
  },
  defaultError: function defaultError(error) {
    if (error.message != 'User closed widget') {
      _backbone.default.trigger('triggerNotification:error', error.message);
    }
  },
  close: function close() {
    this.uploadWidget.close({
      quiet: true
    });
  },
  uploadWithPlugin: function uploadWithPlugin(options) {
    var thisView = this;
    if (this.isPluginUploading) return;
    this.isPluginUploading = true;
    return (0, _injectedUploader.uploadWithInjectedPlugin)(this.uploaderPlugin, {
      onSuccess: function onSuccess(url) {
        thisView.image = url;
        var success = _underscore.default.isFunction(options.success) && options.success || thisView.defaultSuccess;
        success();
      },
      onError: function onError(error) {
        var onError = _underscore.default.isFunction(options.error) && options.error || thisView.defaultError;
        onError(error);
      }
    }).then(function () {
      thisView.isPluginUploading = false;
    }, function (error) {
      thisView.isPluginUploading = false;
      throw error;
    });
  },
  uploadImage: function uploadImage(options) {
    var thisView = this;

    if (this.uploaderPlugin) {
      return this.uploadWithPlugin(options || {});
    }

    if (!this.uploadWidget) {
      this.uploadWidget = this.cloudinary && this.cloudinary.openUploadWidget(thisView.cloudinaryOptions, function (cloudinaryError, result) {
        if (cloudinaryError) {
          var error = _underscore.default.isFunction(options.error) && options.error || thisView.defaultError;
          return error(cloudinaryError);
        }

        if (result && result.event === 'success') {
          var imageURL = result.info.secure_url; // handle IE9

          if (!imageURL) {
            imageURL = 'https://res.cloudinary.com/' + _config.default.cloudinaryCloudName + '/image/upload/' + result.info.path.split('.')[0];
          }

          var arr = imageURL.split('upload');
          var croppedImageUrl = arr[0] + 'upload/f_auto,c_scale,c_crop,g_custom' + arr[1].split('.')[0];
          thisView.image = croppedImageUrl;
          var success = _underscore.default.isFunction(options.success) && options.success || thisView.defaultSuccess;
          success();
        }
      });
      this.uploadWidget.open();
    } else if (!this.uploadWidget.isShowing()) {
      this.uploadWidget.open();
    }
  }
});

var _default = AccountImageView;
exports.default = _default;